"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sulbiate": {
    "fe27eff8": [{
      "hkey": "50b17b11",
      "slug": "sulbiate",
      "name": "Sulbiate",
      "primary": true,
      "skipSearch": false
    }],
    "brentana": [{
      "hkey": "50b17b11",
      "slug": "sulbiate",
      "name": "Sulbiate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3f4b2b2b": [{
      "hkey": "50b17b11",
      "slug": "sulbiate",
      "name": "Sulbiate",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-orobona": [{
      "hkey": "50b17b11",
      "slug": "sulbiate",
      "name": "Sulbiate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;